import {SagaIterator} from 'redux-saga';

import {takeLatest, select, put, call, all} from 'redux-saga/effects';
import {
    reset,
    setOption,
    toggleOption,
} from 'features/wizardMs/reducers/customerConfiguration/customerConfiguration';
import {MetaOptionsType} from 'features/wizardMs/reducers/customerConfiguration/customerConfigurationType';
import {ActionType} from 'constants/flow/flowTypes';
import {getActiveUsage} from 'features/wizardMs/reducers/usages/usages';
import {getActivePackage} from 'features/wizardMs/selectors/packages/packages';
import {APP, PRODUCT} from 'constants/actions';
import {changeStep, USAGE} from 'features/wizardMs/reducers/wizardStep/wizardStep';
import {getPage} from 'selectors/pageApp/pageApp';

/**
 * Provides the wizard reset in case, when we switches product
 */
export function* resetAll(): SagaIterator {
    const [pageName] = yield all([select(getPage)]);
    if (pageName === 'product' || pageName === 'productEdit') {
        yield put(reset());
        yield put(changeStep(USAGE));
    }
}

/**
 * Reset all upsells when customer changes the package
 */
export function* resetOnPackageSelection() {
    const [selectedUsage, selectedPackage] = yield all([
        select(getActiveUsage),
        select(getActivePackage),
    ]);
    yield put(reset());
    yield put(
        setOption({
            [selectedUsage.parentNodeId]: selectedUsage.node,
            [selectedPackage.parentNodeId]: selectedPackage.node,
        }),
    );
}

/**
 * Provides the wrapper on reset functionality
 * @param {Object} payload - selected option
 * @param {MetaOptionsType} meta - meta data with type of option
 */
export function* resetSpecificOptions({
    meta,
}: ActionType<{parentNodeId: number; node: number}, MetaOptionsType>): SagaIterator {
    if (!meta) return;
    if (meta.type === 'package') yield call(resetOnPackageSelection);
}

/**
 * Root
 */
export function* wizardResets(): SagaIterator {
    yield takeLatest([APP.SAVE_LOCATION, PRODUCT.RESET_ALL_STEPS], resetAll);
    yield takeLatest([`${setOption}`, `${toggleOption}`], resetSpecificOptions);
}
